"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateColumnId = exports.findColumnById = exports.createFilterSortHandler = exports.createExternalFilterSortHandlers = exports.applyFiltersAndSorting = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var findColumn = function findColumn(columns, columnId) {
  return columns.find(function (col) {
    var generatedId = "column".concat(col.headerName, "-").concat(col.field);
    return generatedId === columnId || col.field === columnId;
  });
};
var applyColumnFilters = function applyColumnFilters(rows, columnId, filterValues, columns) {
  var column = findColumn(columns, columnId);
  if (!column) return rows;
  return rows.filter(function (row) {
    var _row$column$field;
    return filterValues.includes(String((_row$column$field = row[column.field]) !== null && _row$column$field !== void 0 ? _row$column$field : ""));
  });
};
var resolveSortConfig = function resolveSortConfig(sortFilters, columns) {
  var result;
  for (var _i = 0, _Object$entries = Object.entries(sortFilters); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      columnId = _Object$entries$_i[0],
      filterData = _Object$entries$_i[1];
    if (!filterData.sort) continue;
    var column = findColumn(columns, columnId);
    if (column) {
      result = {
        field: column.field,
        direction: filterData.sort === "desc" ? "desc" : "asc"
      };
    }
  }
  return result;
};

/**
 * Applies filters and sorting to an array of rows based on the provided sort filters configuration.
 *
 * @param rows - Array of row data to filter and sort
 * @param sortFilters - Configuration object containing filter and sort settings for each column
 * @param columns - Grid column definitions for mapping column IDs to fields
 * @returns Filtered and sorted array of rows
 */
var applyFiltersAndSorting = exports.applyFiltersAndSorting = function applyFiltersAndSorting(rows, sortFilters, columns) {
  if (!rows || !columns) return rows;
  var filteredRows = _toConsumableArray(rows);
  for (var _i2 = 0, _Object$entries2 = Object.entries(sortFilters); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      columnId = _Object$entries2$_i[0],
      filterData = _Object$entries2$_i[1];
    if (filterData.filters && filterData.filters.length > 0) {
      filteredRows = applyColumnFilters(filteredRows, columnId, filterData.filters, columns);
    }
  }
  var sort = resolveSortConfig(sortFilters, columns);
  if (!sort) return filteredRows;
  return filteredRows.sort(function (a, b) {
    var _a$sort$field, _b$sort$field;
    var comparison = String((_a$sort$field = a[sort.field]) !== null && _a$sort$field !== void 0 ? _a$sort$field : "").localeCompare(String((_b$sort$field = b[sort.field]) !== null && _b$sort$field !== void 0 ? _b$sort$field : ""));
    return sort.direction === "desc" ? -comparison : comparison;
  });
};

/**
 * Creates a callback function for handling filter and sort updates.
 *
 * @param setSortFilters - State setter function for sortFilters
 * @returns Callback function that updates the sortFilters state
 */
var createFilterSortHandler = exports.createFilterSortHandler = function createFilterSortHandler(setSortFilters) {
  return function (columnId, sortValue, selectedFilters) {
    setSortFilters(function (prev) {
      var keys = Object.keys(prev);
      var modifiedPrev = _objectSpread({}, prev);
      for (var _i3 = 0, _keys = keys; _i3 < _keys.length; _i3++) {
        var key = _keys[_i3];
        if (sortValue) {
          modifiedPrev[key].sort = undefined;
        }
      }
      return _objectSpread(_objectSpread({}, modifiedPrev), {}, _defineProperty({}, columnId, {
        sort: sortValue,
        filters: selectedFilters
      }));
    });
  };
};

/**
 * Finds a column by its generated ID or field name.
 *
 * @param columns - Array of grid column definitions
 * @param columnId - The column ID to search for
 * @returns The matching column definition or undefined
 */
var findColumnById = exports.findColumnById = function findColumnById(columns, columnId) {
  return columns.find(function (col) {
    var generatedId = "column".concat(col.headerName, "-").concat(col.field);
    return generatedId === columnId || col.field === columnId;
  });
};

/**
 * Generates a unique column ID based on header name and field name.
 *
 * @param headerName - The column header name
 * @param fieldName - The column field name
 * @returns Generated column ID string
 */
var generateColumnId = exports.generateColumnId = function generateColumnId(headerName, fieldName) {
  return "column".concat(headerName, "-").concat(fieldName);
};

/**
 * Creates functions for external sort and filter management.
 *
 * @param setSortFilters - State setter function for sortFilters
 * @returns Object with functions for managing filters and sorts externally
 */
var createExternalFilterSortHandlers = exports.createExternalFilterSortHandlers = function createExternalFilterSortHandlers(setSortFilters) {
  /**
   * Applies sort and filter to a specific column from external components.
   *
   * @param columnId - The column identifier
   * @param sortValue - The sort direction ("asc", "desc", or undefined)
   * @param selectedFilters - Array of filter values to apply
   */
  var applyColumnSortFilter = function applyColumnSortFilter(columnId, sortValue, selectedFilters) {
    setSortFilters(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, columnId, {
        sort: sortValue,
        filters: selectedFilters || []
      }));
    });
  };

  /**
   * Clears all sorts and filters from all columns.
   */
  var clearAllSortFilters = function clearAllSortFilters() {
    setSortFilters({});
  };

  /**
   * Removes sort and filter from a specific column.
   *
   * @param columnId - The column identifier to clear
   */
  var clearColumnSortFilter = function clearColumnSortFilter(columnId) {
    setSortFilters(function (prev) {
      var newFilters = _objectSpread({}, prev);
      delete newFilters[columnId];
      return newFilters;
    });
  };
  return {
    applyColumnSortFilter: applyColumnSortFilter,
    clearAllSortFilters: clearAllSortFilters,
    clearColumnSortFilter: clearColumnSortFilter
  };
};